import React, { useEffect } from "react";

const CATALOG_URL = "https://media.chio-chio.ru/";

const DesignMaketPage: React.FC = () => {
    useEffect(() => {
        window.location.replace(CATALOG_URL);
    }, []);

    return (
        <main style={{ padding: "48px 24px", textAlign: "center" }}>
            <h1>Открываем библиотеку макетов</h1>
            <p>
                Если переход не произошёл, <a href={CATALOG_URL}>откройте каталог макетов</a>.
            </p>
        </main>
    );
};

export default DesignMaketPage;
